import React from 'react';
import { Button, Text, View } from 'react-native';
import Amplify, { Auth, Hub } from 'aws-amplify';
import { withOAuth } from "aws-amplify-react-native";
import awsconfig from './src/auth/aws-exports';
import ForgotPassword from './src/auth/ForgotPassword';
import SignIn from './src/auth/SignIn';
import SignUp from './src/auth/SignUp';
import Home from './src/Home'

Amplify.configure(awsconfig);

class Authenticator extends React.Component {
  static defaultProps = {
    initialState: 'default',
    initialData: {},
    onAuthenticated: (authData) => { console.log(`onAuthenticated(${JSON.stringify(authData, null, 2)}`); }
  };
 
  constructor(props) {
    super(props);
    this.state = {
      authState: this.props.initialState,
      authData: this.props.initialData,
    };
  }
 
  onAuthStateChange(newState, newData) {
    const data = Object.assign({}, this.state.authData, newData);
    this.setState({ authState: newState, authData: data });
    if (newState === 'authenticated') {
      this.props.onAuthenticated(data);
    }
  }

  render() {
    const props = {
      authData: this.state.authData,
      authState: this.state.authState,
      onAuthStateChange: (s,d) => this.onAuthStateChange(s,d)
    };

    switch (this.state.authState) {
      case 'forgotPassword':
        return <ForgotPassword {...props}/>;
      case 'signUp':
        return <SignUp {...props} />;
      case 'authenticated':
        return <Home {...props} />;
      case 'signIn':
      default:
        return <SignIn {...props} />;
    };
  }
}
 
export default Authenticator;